import { User } from '@breathelife/types';

import ApiService from './ApiService';

export async function syncUser(auth0Id: string, lang?: string): Promise<User> {
  const response = await ApiService.admin.syncUser(auth0Id, lang);
  return response.data || {};
}
